/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { CalendarTask } from './calendar-task';

export class CalendarDay {
  public date: Date;
  public tasks: CalendarTask[];
  public height: number;

  public rows: CalendarTask[][];

  constructor(date: Date, tasks: CalendarTask[]) {
    this.date = date;
    this.tasks = tasks;
    this.buildTaskRows();
  }

  public buildTaskRows() {
    this.rows = [];
    for (const task of this.tasks.sort((a, b) =>
      a.dateStart.isBefore(b.dateStart) ? -1 : 1,
    )) {
      this.checkRows(task);
    }
    this.height = this.rows.length;
  }

  private checkRows(insert: CalendarTask) {
    for (let i = 0; i < this.rows.length; ++i) {
      const row = this.rows[i];
      let conflict = false;
      for (const task of row) {
        const x1 = task.dateStart.toDate().getTime();
        const y1 = task.dateEnd.toDate().getTime();
        const x2 = insert.dateStart.toDate().getTime();
        const y2 = x2 + insert.dateStart.toDate().getTime();
        const firstCondition = (x1 >= x2 && x1 < y2) || (x1 <= x2 && y1 > x2);
        const secondCondition = (y1 > x2 && y1 <= y2) || (y1 < x2 && x1 >= x2);
        if (firstCondition || secondCondition) {
          conflict = true;
          break;
        }
      }
      if (!conflict) {
        row.push(insert);
        return;
      }
    }
    this.rows.push([insert]);
  }
}
